import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { resolverDestinoDetalle } from '../services/resolverDestinoCrear';

// El ítem "Bolsas" del menú (path /cotizaciones/borradores) SIEMPRE aterriza en el
// Detalle de Cotización, que lista las cotizaciones en borrador en su franja (SPEC-205). Usa el resolver
// único `resolverDestinoDetalle` (abrirCrear=false → sin pop-up), el MISMO que usa
// "Crear": ambos ítems comparten una sola lógica de aterrizaje para que no vuelvan
// a divergir. Si no hay ninguna cotización en borrador, cae en /cotizaciones/detalle (estado vacío
// del Detalle) — nunca en Catálogo ni en Centro. Ver contrato en resolverDestinoCrear.ts.
export function BorradoresRedirect(): React.ReactElement {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const hasNavigatedRef = useRef(false);

  useEffect(() => {
    let cancelled = false;

    resolverDestinoDetalle({ abrirCrear: false })
      .then((destino) => {
        if (cancelled || hasNavigatedRef.current) return;
        hasNavigatedRef.current = true;
        navigate(destino.path, { replace: true });
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'Error cargando bolsas');
      });

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (error) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        {error}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <CircularProgress sx={{ color: '#A3489D' }} />
    </Box>
  );
}
